import { window } from '../window.js';
import { settings } from './settings.js';

const pages = [
  'login',
  'signup',
  'contact-us',
  'reset-pwd',
  'cancel-pwd-recovery',
  'loc',
  'maps',
];

if (!settings.storeDisabled) {
  pages.push('store');
}

/**
 * Represents the document location search params.
 */
class AppParams {
  constructor() {
    let params = new URL(window.location.href).searchParams;
    let mainpage = window.location.pathname.substring(1);
    this.page = pages.find(p => p == mainpage);

    // Pages, having own processing, that should be loaded not depending on
    // the app state, including the history state.
    this.isExtantPage = ['contact-us', 'loc', 'maps'].includes(this.page);

    switch (mainpage) {
      case 'accept-invite':
        this.inviteHash = params.get('hash');
        break;

      case 'reset-pwd':
      case 'cancel-pwd-recovery':
        this.pwdRecoveryHash = params.get('hash');
        break;

      case 'recover-pwd':
        this.recoverPwd = true;
        break;

      case 'maps':
      case 'loc':
        this.locId = parseInt(params.keys().next().value);
        break;

      default:
        break;
    }

    if (!this.inviteHash && params.has('accept-invite')) {
      this.inviteHash = params.get('hash');
    }

    this.email = params.get('email');
    this.timeout = params.has('timeout');
  }
}

export { AppParams };
